import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function GoogleAdsMonoIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 21 20" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M7.147 2.416c.203-.533.482-1.023.896-1.42 1.658-1.616 4.398-1.21 5.523.82.846 1.539 1.742 3.044 2.613 4.567 1.455 2.528 2.927 5.057 4.364 7.594 1.21 2.123-.101 4.804-2.503 5.168-1.472.22-2.85-.457-3.611-1.776-1.277-2.224-2.563-4.449-3.84-6.665a.763.763 0 0 0-.093-.135c-.135-.11-.194-.27-.28-.414-.566-.998-1.15-1.988-1.716-2.977-.364-.643-.744-1.277-1.108-1.92a3.502 3.502 0 0 1-.465-1.86c.025-.34.068-.677.22-.982Z"
      />
      <Box
        as="path"
        fill="currentColor"
        d="M7.144 2.416a4.865 4.865 0 0 0-.16.93c-.026.71.152 1.37.507 1.988a886.56 886.56 0 0 1 2.783 4.812c.084.144.152.288.236.423-.507.88-1.014 1.75-1.53 2.63-.71 1.227-1.421 2.461-2.14 3.688-.034 0-.042-.017-.05-.043-.01-.067.016-.126.033-.194.347-1.269.06-2.393-.812-3.358-.533-.583-1.21-.913-1.987-1.023-1.015-.144-1.912.118-2.715.753-.144.11-.237.27-.406.355-.034 0-.05-.017-.06-.042.407-.702.804-1.404 1.21-2.106 1.675-2.91 3.35-5.819 5.032-8.72.017-.034.043-.06.06-.093Z"
        opacity=".7"
      />
      <Box
        as="path"
        fill="currentColor"
        d="M.88 13.36c.16-.144.312-.296.481-.431 2.056-1.624 5.142-.449 5.59 2.123.11.617.051 1.209-.135 1.801a.885.885 0 0 1-.033.144c-.077.135-.144.279-.229.414-.752 1.243-1.86 1.86-3.315 1.768C1.573 19.06.262 17.809.034 16.15c-.11-.803.05-1.556.465-2.25.084-.152.186-.287.279-.44.042-.033.025-.101.101-.101Z"
      />
      <Box as="path" fill="currentColor" d="M6.784 16.997c-.034-.059 0-.101.033-.143l.034.033-.067.11Z" />
    </Icon>
  );
}
